import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'

import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { Geolocation } from './geolocation.models'

@Injectable({
  providedIn: 'root',
})
export class GeolocationApiService {
  constructor(
    protected http: HttpClient,
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
  ) {}

  getGeolocation(): Observable<Geolocation> {
    const url = `https://api.ipdata.co?api-key=${this.appConfig.ipDataKey}`
    return this.http.get<Geolocation>(url, { withCredentials: false })
  }
}
